<template>
  <div class="zl-page flex_default_center">
    <div class="zl-content flex">
      <div class="zl-box flex_column_align_center">
        <div class="all-car-box">
          <div>
            <div
              class="zl-icon flex_default_center"
              @click="handleAllCar"
              style="cursor: pointer"
            >
            <div>
              <p>{{ $t("zlfk.zc") }}</p>
              <span>Vehicle quality feedback</span>
            </div>
            <img src="../../assets/image/vehicleIcon.png" alt="" />
            </div>
          </div>

          <div v-if="showCarType" class="car-type">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('zlfk.preSalesTip')"
              placement="right"
            >
              <div @click="toPage(2)" style="cursor: pointer">
                <img
                  src="../../assets/image/preSalesIcon.png"
                  alt=""
                  style="margin: 0 15px"
                />
                <div style="margin-left: 15px">
                  <p>{{ $t("zlfk.preSales") }}</p>
                  <span>Pre Sales</span>
                </div>
              </div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('zlfk.afterSalesTip')"
              placement="right"
            >
              <div @click="toPage(3)" style="cursor: pointer">
                <img
                  src="../../assets/image/afterSalesIcon.png"
                  alt=""
                  style="margin: 0 15px"
                />
                <div style="margin-left: 15px">
                  <p>{{ $t("zlfk.afterSales") }}</p>
                  <span>After Sales</span>
                </div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="zl-box flex_column_align_center">
        <div @click="toPage(1)" style="cursor: pointer" class="all-car-box">
          <div class="zl-icon flex_default_center">
            <div>
              <p>{{ $t("zlfk.kd") }}</p>
              <span>KD quality feedback</span>
            </div>
            <img src="../../assets/image/KD.png" alt="" class="box_img" />
          </div>
        </div>
      </div>
      <div class="zl-box flex_column_align_center">
        <div class="all-car-box">
          <div>
            <div
              class="zl-icon flex_default_center"
              @click="toPage(4)"
              style="cursor: pointer"
            >
            <div>
              <p>{{ $t("upgrade.title") }}</p>
              <span>Vehicle quality upgrade</span>
            </div>
            <img src="../../assets/image/upgradeIcon.png" alt="" class="box_img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showCarType: false,
    };
  },
  mounted() {
    // 移除搜索数据
    ['preSales', 'preSalesDetail', 'afterSales', 'afterSalesDetail', 'kdFeedback'].forEach(key => {
      sessionStorage.removeItem(key);
    });
  },
  methods: {
    toPage(type) {
      if(type == 1) {
        this.$router.push("/qualityNew/qualityKD");
      } else if (type == 2) {
        this.$router.push("/qualityNew/preSalesList");
      } else if (type == 3) {
        this.$router.push("/qualityNew/afterSalesList");
      } else {
        this.$router.push("/qualityNew/qualityUpgrade");
      }
    },
    handleAllCar() {
      this.showCarType = !this.showCarType;
    },
  },
};
</script>
<style lang="scss" scoped>
.zl-page {
  .zl-content {
    width: 95%;
    margin-top: -1.4%;
  }
  .zl-icon {
    background: rgb(249, 252, 255);
    box-sizing: border-box;
    max-width: 400px;
    width: 95%;
    height: 270px;
    border: 1px solid rgba(215, 233, 255, 1);
    border-radius: 15px;
    box-shadow: rgba(247, 247, 247, 1) 0px 1px 2px 0px;
    position: relative;
    display: block;
    // margin: auto;
    >div {
      display: block;
      padding: 10px 15px;
    }
    img {
      width: 50%;
      position: absolute;
      right: 25px;
      bottom: 30px;
    }
    .box_img {
      right: 0px;
    }
  }
  .zl-box {
    width: 33.33%;
    color: #000;
    p {
      font-size: 20px;
      font-weight: bold;
      word-break: break-word;
      margin-bottom: 5px;
    }
    span {
      display: block;
      font-size: 18px;
      color:rgb(27,82,148);
      word-break: break-word;
    }
    .all-car-box {
      position: relative;
      width: 90%;
      max-width: 400px;
    }
    .car-type {
      position: absolute;
      top: 0;
      left: min(calc(95% + 8px), 408px);
      height: 250px;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: max-content;
      z-index: 99;
      > div {
        padding: 10px 20px;
        display: flex;
        align-items: center;
        background: #fff;
        box-sizing: border-box;
        height: 120px;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 4px 0px;
      }
      p {
        line-height: 30px;
        word-break: break-word;
      }
      span {
        color: #000;
        word-break: break-word;
      }
    }
  }
}
</style>

<style lang="scss">
.el-tooltip__popper {
  max-width: 400px;
}
</style>
